module.exports = __webpack_public_path__ + "04_hair_black.6156b725.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/04_hair_black.png
// module id = 7vE0
// module chunks = 0